module.exports = __webpack_public_path__ + "img/animated-logo.d9b6cf63.webp";